import React from 'react';
import './InterviewAlert.css';
import { AlertTriangle, XCircle } from './InterviewIcons';

export const INTERVIEW_ALERT_LABELS = Object.freeze({ dismiss: 'Dismiss' });

/**
 * Inline, severity-aware alert for the interview session.
 * alert: { severity: 'warning' | 'blocking', id?, message, actionLabel?, onAction? }
 * Warnings are dismissible; blocking alerts stay until their action resolves them.
 * The alert's own text comes from the caller; only the chrome copy is a label,
 * shallow-merged from `labels` over INTERVIEW_ALERT_LABELS.
 */
const InterviewAlert = ({ alert, onDismiss, labels = null }) => {
    const L = { ...INTERVIEW_ALERT_LABELS, ...(labels || {}) };

    if (!alert) return null;

    const blocking = alert.severity === 'blocking';

    return (
        <div
            className={`interview-alert ${blocking ? 'interview-alert-blocking' : 'interview-alert-warning'}`}
            role="alert"
        >
            <span className="interview-alert-icon">
                {blocking ? <XCircle size={16} /> : <AlertTriangle size={16} />}
            </span>
            <span className="interview-alert-message">{alert.message}</span>
            <span className="interview-alert-actions">
                {alert.actionLabel && alert.onAction && (
                    <button className="interview-alert-btn" onClick={alert.onAction}>
                        {alert.actionLabel}
                    </button>
                )}
                {!blocking && onDismiss && (
                    <button
                        className="interview-alert-dismiss"
                        onClick={onDismiss}
                        aria-label={L.dismiss}
                    >
                        ×
                    </button>
                )}
            </span>
        </div>
    );
};

export default InterviewAlert;
